// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.75.1/styles/" + "videojs" + ".chunk.css?" + "0962e443be072e8b830f" + "";
};